var map = {
  "./error/vi.json": [
    "19506",
    [
      943
    ]
  ],
  "./ro.json": [
    "98911",
    [
      372
    ]
  ],
  "./error/ro.json": [
    "49592",
    [
      713
    ]
  ],
  "./tooltip/ro.json": [
    "74795",
    [
      768
    ]
  ],
  "./tooltip/vi.json": [
    "74389",
    [
      182
    ]
  ],
  "./vi.json": [
    "16809",
    [
      978
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 24933;
module.exports = __rspack_async_context;
